/* eslint-disable jsx-a11y/label-has-for */
import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { RailsContextInterface } from 'contexts/RailsContext'
import { media } from 'styles/media'
import FullLogo from 'components/icons/BrandLogoPositive'
import EmailSignup from 'components/form/EmailSignup'
import StaticWrapper from 'pages/static/StaticWrapper'
import Horizon from './Horizon'
import FooterMenu from './FooterMenu'
import SocialMenu from './SocialMenu'

const Wrapper = styled.footer`
  width: 100%;
  overflow: hidden;
`

const InnerWrapper = styled.div`
  padding: 24px 0;
  padding-bottom: 46px;
  color: white;
  background-color: ${({ theme }) => theme.brand.jungle};
`

const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 16px;
  flex-wrap: wrap;

  ${media.lg`
    display: flex;
    flex-direction: row-reverse;
    gap: 5%;
  `};
`

const Container = styled.div`
  ${media.lg`
    &:first-of-type {
      width: 53%;
    }

    &:last-of-type {
      width: 42%;
    }
  `}
`

const EmailSignupContainer = styled.div`
  form {
    margin-top: 0;
  }

  label {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-sm']?.['font-size']?.value};
  }

  button[type='submit'] {
    background-color: ${({ theme }) => theme?.['-ds-core-300']?.value};
    color: #ffffff;
  }
`

const Bullet = styled.div`
  display: none;
  margin: 0 16px;
`

const Logo = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.white};

  svg {
    display: inline-block;
    width: 156px;
  }
`

const Acknowledgement = styled.div`
  display: block;
  margin-bottom: 24px;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};
`

const Footnote = styled.div`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxxs']?.['font-size']?.value};
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 1px;

  ${media.md`
    font-size: 12px;
  `}
`

const FootnoteMenu = styled.ul`
  margin-top: 8px;
  display: flex;
  list-style: none;
  padding: 0;
  gap: 4px;

  a {
    font-weight: 500;
    color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};

    &:hover {
      color: ${({ theme }) => theme?.['-ds-neutral-200']?.value};
      text-decoration: none;
    }
  }
`

interface FooterProps {
  currentYear: number
  acknowledgement: string
}

const Footer = ({ currentYear, acknowledgement }: FooterProps) => {
  const { lg: isLg } = useMediaQueryContext()

  return (
    <Wrapper>
      <Horizon />

      <InnerWrapper>
        <Inner>
          <Container>
            {!isLg && (
              <EmailSignupContainer>
                <EmailSignup labelInner="Get the best escapes straight to your inbox" />
              </EmailSignupContainer>
            )}

            <FooterMenu />
          </Container>

          <Container>
            {isLg && (
              <EmailSignupContainer>
                <EmailSignup
                  labelInner="Get the best escapes straight to your inbox"
                  buttonLabel="Sign up"
                />
              </EmailSignupContainer>
            )}

            <Logo>
              <FullLogo />
            </Logo>

            <Acknowledgement
              dangerouslySetInnerHTML={{ __html: acknowledgement }}
            />

            <SocialMenu />

            <Footnote>
              <div>#LIVEFULLY WITH RIPARIDE</div>
              <Bullet>&bull;</Bullet>
              <FootnoteMenu>
                <li>&copy; {currentYear} RIPARIDE PTY LTD</li>
                <li>
                  <Bullet>&bull;</Bullet>
                </li>
                <li>
                  <a href="/terms"> &bull; Terms</a>
                </li>
                <li>
                  <a href="/privacy">&bull; Privacy</a>
                </li>
              </FootnoteMenu>
            </Footnote>
          </Container>
        </Inner>
      </InnerWrapper>
    </Wrapper>
  )
}

export default (props: FooterProps, railsContext: RailsContextInterface) => (
  <StaticWrapper {...railsContext}>
    <Footer {...props} />
  </StaticWrapper>
)
